// Ensures Firebase Auth has a user before httpsCallable (Cloud Functions require request.auth).
import { auth } from "./firebase";

/**
 * @returns {Promise<{ ok: true, user: import("firebase/auth").User } | { ok: false, message: string }>}
 */
export async function ensureCallableAuthContext() {
  try {
    const u = auth.currentUser;
    if (!u) {
      return { ok: false, message: "Sign in to use this action." };
    }
    await u.getIdToken(true);
    return { ok: true, user: u };
  } catch (e) {
    const code = e?.code || "";
    const raw = e?.message || String(e);
    if (
      code === "auth/operation-not-allowed" ||
      /anonymous sign-in is disabled/i.test(raw) ||
      /operation-not-allowed/i.test(code)
    ) {
      return {
        ok: false,
        message:
          "Your browser may be running an old version of this app. Sign out, hard-refresh the page (⌘⇧R or Ctrl+Shift+R), sign in again, then retry.",
      };
    }
    return { ok: false, message: raw };
  }
}
